import { useContext, useState, useEffect, useCallback, useMemo, useRef } from 'react';
import "./form-viewer.scss"
import { Popup } from 'devextreme-react/popup';
import { getForm } from './api-requests';
import { Oval } from 'react-loader-spinner'

const FormViewer = ({ taskID, forms }) => {

    const [form, setForm] = useState(null);
    const [height, setHeight] = useState(149);
    const [width, setWidth] = useState(480);
    const popFormViewRef = useRef(null);

    const handleFormClick = async (formID) => {

        var form = await getForm(formID, taskID);

        if (form == null)
            return;

        if (form.width)
            setWidth(form.width);

        if (form.height)
            setHeight(form.height);

        setForm(form);
    };


    useEffect(() => {
        const handleMessage = (event) => {
          
            // Access the message data from event.data
            const messageData = event.data;

            if (!messageData || !messageData.mode)
                return;

            if (messageData.mode === 'form') {
            
            }
            else if (messageData.mode === "isFormResultUpload") {

                if (form == null)
                    return;

                if (form.closeType === 2 || form.closeType === 3) {
                    setForm(null);
                }
            }

        };

        // Add the event listener for 'message' events
        window.addEventListener('message', handleMessage);

        // Don't forget to remove the event listener when the component unmounts
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, [form]);


    //const onChange = useCallback((id, value) => {
    //    setImages(prevItems => prevItems.map((item, index) => {
    //        return index !== id ? item : { value: value }
    //    }))
    //}, [])

    if (!forms || !forms.length)
        return <></>

    return (

        <div>

            <div className={forms && forms.length > 1 ? "form-viewer" : "form-viewer-single" }>

                {forms.map((form, index) => {

                    return (

                        <div key={index}>
                            <button
                                onClick={() => handleFormClick(form.Key)}

                            >{form.Value}</button>
                        </div>
                    )
                })
                }

            </div>

            <Popup

                ref={popFormViewRef}
                height={height}
                width={width}
                visible={form != null}
                hideOnOutsideClick={true}
                showCloseButton={true}
                showTitle={false}
                dragEnabled={false}
                onHiding={() => { setForm(null); }}
            >
                <div className="content dxPopupFormViewContent">
                    <Oval height={60}
                        width={60}
                        color="#dedede"
                        secondaryColor="#dedede"
                        strokeWidth={2}
                        strokeWidthSecondary={2}
                        visible={!height}

                    ></Oval>
                    <iframe style={{ visibility: height ? "visible" : "hidden" }} src={form && form.url ? form.url : ''}>

                    </iframe>
                </div>

            </Popup>

        </div>
    );
};

export default FormViewer;



